import React, { useState, useEffect, useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import './Reviews.css';
import avatar1 from '../../assets/images/ava-001.jpg';
import avatar2 from '../../assets/images/ava-002.jpg';
import avatar3 from '../../assets/images/ava-003.jpg';

const Reviews = () => {
  const [animatedPercentages, setAnimatedPercentages] = useState([0, 0, 0]);
  const [hasAnimated, setHasAnimated] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  const reviews = [
    {
      id: 1,
      text: 'Быстро помогли с чеками за жилье. Взял гостиничные чеки с qr и другие документы от местного отеля. Ставлю 5 звезд за низкую комиссию, на дороге просят намного дороже!',
      avatar: avatar1,
      name: 'Валерий',
      position: 'водитель экспедитор'
    },
    {
      id: 2,
      text: 'Был в командировке в Челябинске. В хостеле, где ночевал, мне ничего не предоставили, а здесь помогли все оформить задним числом и кассовые чеки гостиницы, и счет 3Г.',
      avatar: avatar2,
      name: 'Андрей С.Т.',
      position: 'региональный менеджер'
    },
    {
      id: 3,
      text: 'Смогли предоставить доказательства закупки стройматериалов, которые приобретались на стройку за наличку. Наша халатность в документах обошлась недорого, будем обращаться.',
      avatar: avatar3,
      name: 'Анатолий',
      position: 'начальник объекта'
    }
  ];

  const stats = useMemo(() => [
    { label: 'Чеки за проживание в гостинице', percentage: 70 },
    { label: 'Строительные чеки', percentage: 20 },
    { label: 'Отчет для ЮЛ', percentage: 10 }
  ], []);

  useEffect(() => {
    if (inView && !hasAnimated) {
      setHasAnimated(true);
      
      // Анимация прогресс-баров
      stats.forEach((stat, index) => {
        const targetPercentage = stat.percentage;
        let currentPercentage = 0;
        const increment = targetPercentage / 50; // 50 шагов анимации
        const interval = 20; // 20ms между шагами = 1 секунда анимации

        const timer = setInterval(() => {
          currentPercentage += increment;
          if (currentPercentage >= targetPercentage) {
            currentPercentage = targetPercentage;
            clearInterval(timer);
          }
          
          setAnimatedPercentages(prev => {
            const newPercentages = [...prev];
            newPercentages[index] = Math.round(currentPercentage);
            return newPercentages;
          });
        }, interval);
      });
    }
  }, [inView, hasAnimated, stats]);

  return (
    <section className="reviews section" ref={ref}>
      <div className="container">
        <div className="reviews__content">
          <div className="reviews__info">
            <h2 className="reviews__title">ЗАБОТА О КЛИЕНТАХ</h2>
            <div className="reviews__text">
              <p>
                Мы соблюдаем конфиденциальность на всех этапах взаимодействия с клиентом. 
                Во всех внутренних базах компании ваше обращение отражается как обычное 
                клиентское посещение в указанные даты: проживание в гостинице или закупка 
                строительных материалов задним числом.
              </p>
              <p>
                Чаще всего к нам обращаются с проблемой потерянных или неоформленных 
                документов для того, чтобы благополучно сдать отчет.
              </p>
              <p>
                Мы помогаем отразить реально понесенные расходы в чеках, по которым можно 
                будет вернуть затраченные суммы или отчитаться при авансовом отчете.
              </p>
              <p><strong>Примерное распределение клиентских запросов:</strong></p>
            </div>

            <div className="reviews__stats">
              {stats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <div className="stat-item__label">{stat.label}</div>
                  <div className="stat-item__bar">
                    <div 
                      className="stat-item__progress" 
                      style={{ width: `${animatedPercentages[index]}%` }}
                      data-percentage={stat.percentage}
                    >
                      <span className="stat-item__percentage">
                        {animatedPercentages[index]}%
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="reviews__additional">
              <p>
                Этот сайт предназначен для заказа чеков в Челябинске и области, но мы работаем 
                и в других городах России – Москве, Санкт-Петербурге и Уфе.
              </p>
              <p>
                Постоянные клиенты, совершающие частые командировки по РФ могут рассчитывать 
                на первоклассный сервис в любом городе присутствия, вкупе с дополнительными 
                условиями сотрудничества.
              </p>
            </div>
          </div>

          <div className="reviews__cards">
            {reviews.map(review => (
              <div key={review.id} className="review-card">
                <div className="review-card__quote">"</div>
                <p className="review-card__text">{review.text}</p>
                <div className="review-card__author">
                  <img src={review.avatar} alt={review.name} className="review-card__avatar" />
                  <div className="review-card__info">
                    <div className="review-card__name">{review.name}</div>
                    <div className="review-card__position">{review.position}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;